<template>
	<b-card
		id="signature-tabs"
		bg-variant="dark"
		header-text-variant="dark"
		body-border-variant="dark"
		no-body>
		<b-tabs v-model="tabIndex" pills card fill>
			<b-tab active>
				<template #title>
					<div class="d-inline-flex justify-content-center align-content-center">
						<div><font-awesome-icon :icon="['fas', 'signature']" /></div>
						<div class="ml-2">Click here to <strong>draw your signature</strong></div>
					</div>
				</template>
				<div id="signature" @mouseleave="saveSignature">
					<vue-signature ref="signature"
						:sig-option="signatureConfig"
						:w="'100%'"
						:h="'200px'"></vue-signature>
					<b-button variant="secondary" class="btn-with-icon mt-3 mr-2" @click="$refs.signature.undo();">
						<span class="btn-label">Undo Last Mark</span>
						<span class="btn-icon"><font-awesome-icon :icon="['fas', 'undo']" /></span>
					</b-button>
					<b-button variant="secondary" class="btn-with-icon mt-3" @click="$refs.signature.clear();">
						<span class="btn-label">Reset Signature</span>
						<span class="btn-icon"><font-awesome-icon :icon="['fas', 'undo']" /></span>
					</b-button>
				</div>
			</b-tab>
			<b-tab>
				<template #title>
					<div class="d-inline-flex justify-content-center align-content-center">
						<div><font-awesome-icon :icon="['fas', 'keyboard']" /></div>
						<div class="ml-2">Click here to <strong>type your signature</strong></div>
					</div>
				</template>
				<canvas id="typedSignatureCanvas" class="d-none" height="100"></canvas>
				<b-form-input id="typed-signature" v-model.trim="typed_signature" placeholder="Your Signature"></b-form-input>
			</b-tab>
		</b-tabs>
	</b-card>
</template>
<script>
import vueSignature from 'vue-signature'

export default {
	components: {
		vueSignature
	},
	props: {
		value: {
			type: String,
			default: () => ''
		}
	},
	data () {
		return {
			handleResize: null,
			prevWindowSize: 0,
			tabIndex: 0,
			canvas: '',
			typed_signature: '',
			signatureConfig: {
				penColor:'rgb(25,25,25)',
				backgroundColor:'rgb(255,255,255)'
			}
		}
	},
	watch: {
		tabIndex () {
			this.$nextTick(() => this.reDrawSignature())
		},
		typed_signature () {
			this.generateTypedSignature()
		}
	},
	mounted () {
		this.prevWindowSize = window.innerWidth
		this.handleResize = _.debounce(this.reDrawSignature, 500)
		window.addEventListener('resize', this.handleResize)
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		saveSignature () {
			// Signature is blank
			if (this.$refs.signature.isEmpty()) {
				this.$emit('input', null)

				return
			}

			// Signature does not have enough data points
			// So we can assume it's probably not a proper signature
			if (! this.$refs.signature || ! this.$refs.signature.sig.hasOwnProperty('_data')) {
				this.$emit('input', null)

				return
			}

			if (this.length(this.$refs.signature.sig['_data']) < 1) {
				this.$emit('input', null)

				return
			}

			let totalDataPoints = 0
			for (const lengthKey in this.$refs.signature.sig['_data']) {
				if (! this.$refs.signature.sig['_data'].hasOwnProperty(lengthKey)) continue
				if (! this.$refs.signature.sig['_data'][lengthKey].hasOwnProperty('points')) continue

				totalDataPoints += this.length(this.$refs.signature.sig['_data'][lengthKey]['points'])
			}

			// Signature must contain at least 5 data points in the canvas to be considered real
			if (totalDataPoints <= 5) {
				this.$emit('input', null)

				return
			}

			this.$emit('input', this.$refs.signature.save('image/svg+xml'))
		},
		generateTypedSignature () {
			if('' === this.typed_signature) {
				this.$emit('input', null)

				return
			}

			let tCtx = document.getElementById('typedSignatureCanvas').getContext('2d'),
				font = '400 50px "Nothing You Could Do"',
				typed_signature = this.typed_signature,
				signature = ''

			document.fonts.load(font)
				.then(() => {
					tCtx.font = font
					// this will reset all our context's properties
					tCtx.canvas.width = tCtx.measureText(typed_signature).width + 60
					// so we need to set it again
					tCtx.font = font
					// set the color only now
					tCtx.fillStyle = '#000'
					tCtx.backgroundColor = '#fff'
					tCtx.fillText(typed_signature, 20, 60)
					signature = tCtx.canvas.toDataURL('image/svg+xml')
					this.$emit('input', signature)
				}, () => false)
		},
		reDrawSignature () {
			if (window.innerWidth < 1000 || (this.prevWindowSize < 1000 && window.innerWidth >= 1000)) {
				this.typed_signature = ''
				this.$refs.signature.clear()
				this.$refs.signature.draw()
				this.$nextTick(() => this.saveSignature())
			}

			this.prevWindowSize = window.innerWidth
		}
	}
}
</script>
